export enum ISOCurrencyCode {
  AUD = "AUD",
  USD = "USD",
  GBP = "GBP",
  EUR = "EUR",
}

export const ISOCurrencyCodeList = () =>
  Object.entries(ISOCurrencyCode).map(([label, value]) => {
    return { label, value };
  });
